import {

  fetchBranchesFail,
  fetchBranchesRequest,
  fetchBranchesSuccess

} from '../store/ActionReducers/branch.actionreducer';
import { httpbase } from '../utils/axios.utils';
import  {Dispatch} from 'redux';
import { lang } from '../config/app.config';


export const fetchBranch = () =>{
  return async (dispatch:Dispatch) =>{
    dispatch(fetchBranchesRequest());
    try{
      const response = await httpbase().get('branch?lang='+lang);
      dispatch(fetchBranchesSuccess(response.data.data));
    }catch(e:any){
      if(e && e.response && e.response.data){
        dispatch(fetchBranchesFail(e.response.data));
      }
      dispatch(fetchBranchesFail("Something went wrong!"));
    }
  }
}

export const fetchBranchBySlug = async (slug:string) =>{
  try{
    const response = await httpbase().get(`branch/${slug}?lang=${lang}`);
    return response.data.data;
  }catch(e:any){
    console.log(e);
  }
}

export const fetchStatsBySlug = async (slug:string) =>{
  try{
    const response = await httpbase().get(`resources/statistics/${slug}?lang=${lang}`);
    return response.data.data;
  }catch(e:any){
    console.log(e);
  }
}